// extracted by mini-css-extract-plugin
export default {"content":"send-budget-modal_content__6UnOl","actions":"send-budget-modal_actions__8RBJo"};